import { globalEndpoints } from './global';

export const lookupEndPoints = {
  getCounties: () => {
    return `${globalEndpoints.apiUrl}/Lookup/Counties`;
  },
  getStates: () => {
    return `${globalEndpoints.apiUrl}/Lookup/States`;
  },
  getPhysicians: () => {
    return `${globalEndpoints.apiUrl}/Lookup/Physicians`;
  },
  getProfessions: () => `${globalEndpoints.apiUrl}/Lookup/GetProfessions`,
  GetPhysicianSuspensionTypes: () => `${globalEndpoints.apiUrl}/Lookup/GetPhysicianSuspensionTypes`,
};
